/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const ADMINISTRATIVEREPRESENTATIVE_ADD = 'ADMINISTRATIVEREPRESENTATIVE_ADD';
export const ADMINISTRATIVEREPRESENTATIVE_BEGIN = 'ADMINISTRATIVEREPRESENTATIVE_BEGIN';
export const ADMINISTRATIVEREPRESENTATIVE_FAILURE = 'ADMINISTRATIVEREPRESENTATIVE_FAILURE';
export const ADMINISTRATIVEREPRESENTATIVE_CLEAR = 'ADMINISTRATIVEREPRESENTATIVE_CLEAR';

export const ADMINISTRATIVEREPRESENTATIVE_FILTER_BEGIN = 'ADMINISTRATIVEREPRESENTATIVE_FILTER_BEGIN';
export const ADMINISTRATIVEREPRESENTATIVE_FILTER_SUCCESS = 'ADMINISTRATIVEREPRESENTATIVE_FILTER_SUCCESS';
export const ADMINISTRATIVEREPRESENTATIVE_FILTER_FAILURE = 'ADMINISTRATIVEREPRESENTATIVE_FILTER_FAILURE';
export const ADMINISTRATIVEREPRESENTATIVE_FILTER_CLEAR = 'ADMINISTRATIVEREPRESENTATIVE_FILTER_CLEAR';

export function fetchAdministrativeRepresentative(params = {}) {
	return async dispatch => {
        dispatch(administrativeRepresentativeBegin());
        await ApiService.getResponsible(params)
			.then(
            result => {
                    dispatch(administrativeRepresentativeAdd(result));
				},
				error => {
                    dispatch(administrativeRepresentativeError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchAdministrativeRepresentativeFilter(params = {}) {
    return async dispatch => {
        await ApiService.getResponsibleFilter(params)
            .then(
                result => {
                    dispatch(administrativeRepresentativeFilterAdd(result));
                },
                error => {
                    dispatch(administrativeRepresentativeFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//AdministrativeRepresentative
export const administrativeRepresentativeBegin = () => ({
    type: ADMINISTRATIVEREPRESENTATIVE_BEGIN,
});

export const administrativeRepresentativeAdd = data => ({
    type: ADMINISTRATIVEREPRESENTATIVE_ADD,
	payload: { data }
})

export const administrativeRepresentativeError = () => ({
    type: ADMINISTRATIVEREPRESENTATIVE_FAILURE,
})

export const administrativeRepresentativeClear = () =>({
    type: ADMINISTRATIVEREPRESENTATIVE_CLEAR,
})

//AdministrativeRepresentative Filters
export const administrativeRepresentativeFilterBegin = () => ({
    type: ADMINISTRATIVEREPRESENTATIVE_FILTER_BEGIN,
});
export const administrativeRepresentativeFilterAdd = filterData => ({
    type: ADMINISTRATIVEREPRESENTATIVE_FILTER_SUCCESS,
    payload: { filterData }
})
export const administrativeRepresentativeFilterError = filterError => ({
    type: ADMINISTRATIVEREPRESENTATIVE_FILTER_FAILURE,
    payload: { filterError }
})

export const administrativeRepresentativeFilterClear = () => ({
    type: ADMINISTRATIVEREPRESENTATIVE_FILTER_CLEAR,
})
